import * as CONST from 'Reducers/Location/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'
import * as MISSION_CONST from './../Mission/const'

const initState = {
  locationById: {},
  locationsByCityId: [],
  locationsByCityIdStatusFilter: CONST.LOCATION_STATUS[0],
  locationsByCityIdSearchValue: '',
  locationsByCityIdSortBy: {
    columnName: null,
    reverse: false,
  },
  locationTypes: [],
  // This is a hash map of locations with the key being the location id and the
  // value being the location data.
  locations: {},
}

export function locations(state = initState, action) {
  switch (action.type) {
    case CONST.GET_LOCATION_BY_ID_SUCCESS: {
      const locationById = Object.assign({}, action.payload.locationById)
      locationById.status =
        action.payload.locationById.status === CONST.STATUS_ENABLED

      return {
        ...state,
        locationById,
      }
    }

    case CONST.CLEAR_LOCATION_BY_ID:
      return {
        ...state,
        locationById: initState.locationById,
      }

    case CONST.GET_LOCATIONS_BY_CITY_ID_SUCCESS:
      var newLocations = {}
      action.payload.locationsByCityId.forEach(location => {
        newLocations[location.id] = location
      })
      return {
        ...state,
        locationsByCityId: action.payload.locationsByCityId,
        locations: {
          ...state.locations,
          ...newLocations,
        },
      }

    case CONST.CLEAR_LOCATIONS_BY_CITY_ID:
      return {
        ...state,
        locationsByCityId: initState.locationsByCityId,
      }

    case CONST.UPDATE_LOCATION_BY_ID_SUCCESS:
      const updatedState = state.locationsByCityId.map(l =>
        l.id === action.locationId ? action.response : l,
      )

      return {
        ...state,
        locationsByCityId: updatedState,
      }

    case CONST.SET_LOCATIONS_BY_CITY_ID_FILTER_STATUS:
      return {
        ...state,
        locationsByCityIdStatusFilter: action.locationsByCityIdStatusFilter,
      }

    case CONST.SET_LOCATIONS_BY_CITY_ID_SEARCH_VALUE:
      return {
        ...state,
        locationsByCityIdSearchValue: action.locationsByCityIdSearchValue,
      }

    case CONST.SET_LOCATIONS_BY_CITY_ID_SORT_BY:
      return {
        ...state,
        locationsByCityIdSortBy: action.locationsByCityIdSortBy,
      }

    case CONST.GET_LOCATION_TYPES_SUCCESS:
      return {
        ...state,
        locationTypes: action.payload.locationTypes,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        locationsByCityIdStatusFilter: initState.locationsByCityIdStatusFilter,
        locationsByCityIdSearchValue: initState.locationsByCityIdSearchValue,
      }

    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS:
      var newLocations = {}
      // Grab all locations
      var campaignData = action.result.data.campaign
      campaignData.cityPlans.nodes.forEach(cityPlan => {
        // Grab all the active city locations
        cityPlan.city.locations.edges.forEach(locationEdge => {
          var location = locationEdge.node
          newLocations[location.id] = {
            ...location,
            type: location.type.name,
            cityId: cityPlan.city.id,
          }
        })
        // Grab all the locations against missions (perhaps includes now
        // inactive locations
        cityPlan.missions.edges.forEach(({ node }) => {
          if (node.location) {
            newLocations[node.location.id] = {
              ...node.location,
              type: node.location.type.name,
              cityId: cityPlan.city.id,
            }
          }
        })
      })
      return {
        ...state,
        locations: {
          ...state.locations,
          ...newLocations,
        },
      }

    case MISSION_CONST.CREATE_MISSIONS_SUCCESS:
      const locations = action.result.reduce((acc, mission) => {
        if (mission.location) {
          acc[mission.location.id] = {
            ...mission.location,
            type: mission.location.type.name,
          }
        }

        return acc
      }, [])

      return {
        ...state,
        locations: {
          ...state.locations,
          ...locations,
        },
      }
    default:
      return state
  }
}
